import { Component, Prop, h, Watch, Element } from '@stencil/core';
import { handleAriaLabelChange } from '../../../shared/aria-utils';

/**
 * In the future, this component should be updated to restrict which icon names can be used:
 * Product icons shouldn't be usable outside of illustrative and contained variants,
 * and illustrative and contained variants should only be able to use product icons.
 */

@Component({
  tag: 'a1-illustrative-icon',
  styleUrl: '../a1-icon.scss',
  scoped: true,
})
export class a1IllustrativeIcon {
  @Element() host!: HTMLA1IllustrativeIconElement;
  /**
   * Icon name.
   */
  @Prop({ reflect: true }) icon: string = 'rewards';

  /**
   * Icon size. For illustrative icons: 'l' or 'xl' is valid
   *
   */
  @Prop({ reflect: true }) size: 'l' | 'xl' = 'l';

  /**
   * Toggle for enabled / disabled icon appearance.
   */
  @Prop({ reflect: true }) disabled: boolean = false;

  /**
   * An alternate description to use for assistive devices. If omitted, the icon will be considered presentational and ignored by assistive devices.
   */
  @Prop() label: string = '';

  /**
   * When true, displays the icon in inverse colors for use on dark backgrounds.
   */
  @Prop({ reflect: true }) inverse: boolean = false;

  /**
   * When true, displays the icon in contained style for use on colored backgrounds.
   * Contained icons are only available for illustrative variants.
   */
  @Prop({ reflect: true }) contained: boolean = false;

  /**
   * Icon size. For illustrative icons: 'l' or 'xl' is valid
   *
   */
  @Prop({ reflect: true }) containedType: 'default' | 'emphasis' = 'default';

  private get classNames() {
    return {
      icon: true,
      illustrative: true,
      [`c-icon--product-${this.icon}`]: true,
      [this.size]: true,
      disabled: this.disabled,
      inverse: this.inverse,
      contained: this.contained,
      [`contained--${this.containedType}`]: this.contained,
    };
  }
  @Watch('label')
  getAriaLabelChange() {
    handleAriaLabelChange(this.host, this.label);
  }

  componentDidLoad() {
    this.getAriaLabelChange();
  }

  render() {
    return <i class={this.classNames}></i>;
  }
}
